import styled from "styled-components";

export const Styles = styled.div`
  .vision-page {
    .vision-section {
      padding: 80px 0;
      // background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      position: relative;
      
      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(255, 255, 255, 0.1);
        backdrop-filter: blur(10px);
      }
      
      @media (max-width: 768px) {
        padding: 40px 0;
      }
    }

    .vision-content {
      background: #ffffff;
      border-radius: 25px;
      padding: 60px 40px;
      box-shadow: 0 25px 70px rgba(0, 0, 0, 0.15);
      position: relative;
      z-index: 2;
      overflow: hidden;

      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 6px;
        background: linear-gradient(90deg, #6A5ACD, #4CAF50, #FF9800, #2196F3, #E91E63);
      }

      @media (max-width: 768px) {
        padding: 40px 20px;
        border-radius: 20px;
      }
    }

    .vision-header {
      text-align: center;
      margin-bottom: 50px;
      
      .vision-icon {
        margin-bottom: 25px;
        
        svg {
          filter: drop-shadow(0 6px 12px rgba(106, 90, 205, 0.4));
        }
      }

      .vision-title {
        font-size: 3.2rem;
        font-weight: 800;
        color: #2c3e50;
        margin: 0;
        position: relative;
        display: inline-block;
        background: linear-gradient(135deg, #6A5ACD, #4CAF50);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;

        &::after {
          content: '';
          position: absolute;
          bottom: -15px;
          left: 50%;
          transform: translateX(-50%);
          width: 100px;
          height: 5px;
          background: linear-gradient(90deg, #6A5ACD, #4CAF50);
          border-radius: 3px;
        }

        @media (max-width: 768px) {
          font-size: 2.4rem;
        }
      }
    }

    .vision-text {
      margin-bottom: 60px;
      text-align: center;
      
      p {
        font-size: 1.3rem;
        line-height: 1.9;
        color: #444;
        margin: 0;
        font-weight: 500;
        max-width: 900px;
        margin: 0 auto;

        @media (max-width: 768px) {
          font-size: 1.15rem;
          text-align: left;
        }
      }
    }

    .vision-pillars {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
      gap: 30px;
      margin-bottom: 60px;

      @media (max-width: 768px) {
        grid-template-columns: 1fr;
        gap: 25px;
      }
    }

    .pillar-item {
      background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
      border-radius: 20px;
      padding: 35px 25px;
      text-align: center;
      transition: all 0.4s ease;
      border: 2px solid transparent;
      position: relative;
      overflow: hidden;

      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: -100%;
        width: 100%;
        height: 100%;
        background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
        transition: left 0.5s;
      }

      &:hover {
        transform: translateY(-10px);
        box-shadow: 0 20px 50px rgba(0, 0, 0, 0.15);
        border-color: #6A5ACD;
        
        &::before {
          left: 100%;
        }
      }

      &:nth-child(1):hover {
        border-color: #4CAF50;
      }
      
      &:nth-child(2):hover {
        border-color: #FF9800;
      }
      
      &:nth-child(3):hover {
        border-color: #2196F3;
      }
      
      &:nth-child(4):hover {
        border-color: #E91E63;
      }

      @media (max-width: 768px) {
        padding: 25px 20px;
      }
    }

    .pillar-icon {
      margin-bottom: 20px;

      svg {
        filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.1));
        transition: transform 0.3s ease;
      }

      .pillar-item:hover & svg {
        transform: scale(1.1);
      }
    }

    .pillar-content {
      h3 {
        font-size: 1.4rem;
        font-weight: 700;
        color: #2c3e50;
        margin-bottom: 15px;
        margin-top: 0;
      }

      p {
        font-size: 1rem;
        color: #666;
        margin: 0;
        line-height: 1.7;
      }
    }

    .vision-impact {
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      border-radius: 20px;
      padding: 40px 30px;
      color: white;
      text-align: center;

      .impact-header {
        margin-bottom: 30px;
        
        h3 {
          font-size: 2rem;
          font-weight: 700;
          margin: 0;
          text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);

          @media (max-width: 768px) {
            font-size: 1.6rem;
          }
        }
      }

      .impact-stats {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
        gap: 30px;

        @media (max-width: 768px) {
          gap: 20px;
        }
      }

      .stat-item {
        .stat-number {
          font-size: 3rem;
          font-weight: 900;
          margin-bottom: 10px;
          text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);

          @media (max-width: 768px) {
            font-size: 2.5rem;
          }
        }

        .stat-label {
          font-size: 1.1rem;
          font-weight: 500;
          opacity: 0.9;

          @media (max-width: 768px) {
            font-size: 1rem;
          }
        }
      }
    }

    /* Responsive adjustments */
    @media (max-width: 1200px) {
      .vision-pillars {
        grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
      }
    }

    @media (max-width: 576px) {
      .vision-content {
        margin: 0 10px;
      }
      
      .vision-pillars {
        grid-template-columns: 1fr;
        gap: 20px;
      }
      
      .pillar-item {
        padding: 20px 15px;
      }
      
      .vision-impact {
        padding: 30px 20px;
      }
    }
  }
`;